import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    NgZone,
    ViewChild,
} from "@angular/core";
import * as moment from "moment";

import { HomeService } from "./home.srevice";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";

import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ChargingStationService } from "app/shared/services/charging-station/charging-station.service";
import { MatDialog } from "@angular/material/dialog";
import { ChargerService } from "app/shared/services/charger/charger.service";
declare var google: any;
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

import {
    Validators,
    FormBuilder,
    FormGroup,
    ValidatorFn,
    AbstractControl,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MessageConstant } from "app/shared/utils/message.constant";
import { Pipe, PipeTransform } from "@angular/core";
import { ViewEncapsulation } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { MatTableFilter } from "mat-table-filter";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { GeoLocationService } from "app/shared/services/map/geo-location.service";
import { AgmMap, MapsAPILoader } from "@agm/core";
import * as XLSX from "xlsx";
import { CountriesService } from "app/shared/services/countries.service";
import { MasterService } from "app/shared/services/master/master.service";
//import { GPU } from 'gpu.js'
import { jsPDF } from "jspdf";
import "jspdf-autotable";
// import { AccountService } from "app/shared/services/account/account.service";
import { SetCpoStationService } from "app/shared/services/setCPOStation.service";

function autocompleteObjectValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (typeof control.value === "string") {
            return { invalidAutocompleteObject: { value: control.value } };
        }
        return null; /* valid option selected */
    };
}
export interface Charger {
    id: number;
    hePartNo: string;
    serialNo: string;
    address: string;
    status: string;
}
interface Radius {
    value: number;
    viewValue: string;
    radiusValue: number;
}
export interface VehicleTypes {
    id: number;
    icon: string;
    name: string;
}
export interface ChStationTypes {
    id: number;
    icon: string;
    name: string;
}
const chargerList: Charger[] = [
    {
        id: 1,
        hePartNo: "he part no1",
        serialNo: "0001",
        address: "Delhi",
        status: "Active",
    },
    {
        id: 2,
        hePartNo: "he part no2",
        serialNo: "0002",
        address: "Bikaner",
        status: "Inactive",
    },
];

export class ChargingStation {
    id: number;
    cpo_id: number;
    cpo_name: string;
    name: string;
    code: string;
    description: string;
    address: string;
    pin: number;
    lat: number;
    lng: number;
    location_type_id: number;
    cp_name: string;
    mobile: number;
    email: string;
    commissioned_dt: string;
    register_as: number;
    electricity_line_id: number;
    o_time: string;
    c_time: string;
    status: string;
    created_date: string;
    created_by: number;
    modify_date: string;
    modify_by: number;
    statusString: string;
    address1: string;
}
export class Marker {
    id: number;
    lat: number;
    lng: number;
    label?: string;
    draggable: boolean;
    status: string;
    name: string;
    rating: number;
    address: string;
    contact: number;
    oTiming: string;
    cTiming: string;
    price: string;
    installationType: string;
    installationArea: string;
    installationStatus: boolean;
    serialNo: string;
    HEPartNo: string;
    link: string;
    infoWindowShow: boolean = true;
}

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,

    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [HomeService, GeoLocationService],
})
export class HomeComponent implements OnInit {
    // displayedColumns: string[] = ['hePartNo','serialNo', 'address', 'status', 'action'];
    circleMapRadius = 5000;
    zoom = 12;
    displayedColumns: string[] = [
        "action",
        "cpo_name",
        "code",
        "name",
        "cp_name",
        "mobile",
        "email",
        "address",
        "status",
    ];
    cpoCunsum: string[] = ["cpo_name", "total_consumption", "total_billed_amt"];
    head = [
        [
            "CPO Name",
            "Station Code",
            "Name",
            "Contact Person",
            "Mobile",
            "Address",
            "Status",
        ],
    ];
    dataSource: MatTableDataSource<ChargingStation>;
    cpoCunsumDataSource = [];
    cpoLedgerDataSource: any = [];
    radius: Radius[] = [
        { value: 5000, viewValue: "5 KM", radiusValue: 15 },
        { value: 10000, viewValue: "10 KM", radiusValue: 10 },
        { value: 15000, viewValue: "15 KM", radiusValue: 5 },
    ];
    vehicleTypes: VehicleTypes[] = [
        { id: 1, icon: "library_add_check", name: "All" },
        { id: 2, icon: "two_wheeler", name: "2W" },
        { id: 3, icon: "two_wheeler", name: "3W" },
        { id: 4, icon: "local_taxi", name: "LMW" },
        { id: 5, icon: "directions_bus", name: "HMW" },
    ];
    chStationTypes: ChStationTypes[] = [
        { id: 1, icon: "library_add_check", name: "All" },
        { id: 2, icon: "groups", name: "Public" },
        { id: 3, icon: "local_library", name: "Community" },
    ];

    chargingStations: ChargingStation[];
    public selected2 = this.radius[0].value;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    stats = this.homeService.getStats();

    localStorage: any;
    lat: number = 28.491583122667347;
    lng: number = 77.06265390059566;
    // radius = 50;
    openedWindow: number = 0; // alternative: array of numbers

    markers: Marker[];
    showStationDetails: boolean = false;
    stationObj: any;
    chargers: any;
    currentlyOpenedItemIndex = -1;
    map: any;
    actionClicked: boolean = false;
    activeState = this.vehicleTypes[0];
    activeChStation = this.chStationTypes[0];
    batteryDial: boolean = false;
    form: FormGroup;
    formCCS: FormGroup;
    formCCS2: FormGroup;
    formCCS3: FormGroup;
    startDate!: string;
    endDate!: string;
    charginingStation: any;
    filteredOptionsChStation: Observable<any[]>;
    search = "";
    citySearch = "";
    timeout = null;
    show = false;
    cityShow = false;
    emptyStation = [];
    filterdChStationOptions = [];
    filterdStationOptions = [];
    filterdCityOptions = [];
    locationSearch: string = "";
    cityOptionSearch: string = "";
    radiusSearch: number = 5;
    chStationSearch: string = "";
    cpoSearch: boolean = false;
    stationSearch: boolean = false;
    nameSearch: boolean = false;
    cpSearch: boolean = false;
    mobileSearch: boolean = false;
    emailSearch: boolean = false;
    addressSearch: boolean = false;
    statusSearch: boolean = false;
    nicknameSearch = false;
    filterEntity: ChargingStation;
    filterType: MatTableFilter;
    exportedData: any[];
    selectedIndex = 0;
    idIndex = 0;
    infoWindowOpened: any;
    previous_info_window: any;
    showingInfoWindow: boolean = false;
    infoMarker: any;
    radiusLat = 0;
    radiusLong = 0;
    stationMarker: ChargingStation[];
    cities: any;
    connectorSearch: any;
    connectorTypes: any;
    //gpu: GPU;
    ameniteExits: boolean = false;
    objectData: any;
    dyanmictab: any;
    dyanmicMapView: boolean = false;
    dyanmicListView: boolean = false;
    dyanmicCpoConsumListView: boolean = false;
    dyanmicCpoStationConsumListView: boolean = false;
    selectedClient_id: any;
    selectedStation_id: any;
    selectedCpo_id: any;
    clientCpoStaDetails: any;
    stationList: any;
    station: any[];
    cpoList: any;
    clientList: any;
    filteredOptionsCharClient: Observable<any[]>;
    filteredOptionsCharCPO: Observable<any[]>;
    filteredOptionsCharStat: Observable<any[]>;
    localCpolist: any[];
    localStationlist: any[];
    clientCpoStaDetail: any;
    localClient: any;
    filterBox: boolean = false;
    listFilterBox: boolean = false;
    listFilterBox1: boolean = false;
    listFilterBox2: boolean = false;
    listFilterBox3: boolean = false;
    ledgerRows: any[] = [];

    constructor(
        private homeService: HomeService,
        private chargingStationService: ChargingStationService,
        private preloader: FuseProgressBarService,
        private ngZone: NgZone,
        private cdr: ChangeDetectorRef,
        private router: Router,
        public dialog: MatDialog,
        private fb: FormBuilder,
        private snackBar: MatSnackBar,
        private chargerService: ChargerService,
        private route: ActivatedRoute,
        public geoLocationService: GeoLocationService,
        private countryService: CountriesService,
        private masterService: MasterService,
        private setCpoStationService: SetCpoStationService,
    ) {
        this.localStorage = JSON.parse(localStorage.getItem("userDetails"));
        const today = new Date();

        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(today.getMonth() - 1);
        const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1,
        );

        this.startDate = this.formatDate(firstDayOfMonth);
        this.endDate = this.formatDate(today);

        //this.gpu = new GPU();
        this.form = this.fb.group({
            chStation: [""],
        });
        this.formCCS = this.fb.group({
            charClient: ["", [autocompleteObjectValidator()]],
            charCPO: ["", [autocompleteObjectValidator()]],
            charStat: ["", [autocompleteObjectValidator()]],
        });
        this.formCCS2 = this.fb.group({
            startDate: [this.startDate],
            endDate: [this.endDate],
        });
        this.formCCS2.valueChanges.subscribe((val) => {
            this.startDate = this.formatDate(new Date(val.startDate));
            this.endDate = this.formatDate(new Date(val.endDate));
            this.cdr.detectChanges();
        });

        this.formCCS3 = this.fb.group({
            startDate: [this.startDate],
            endDate: [this.endDate],
            charClient: ["", [autocompleteObjectValidator()]],
            charCPO: ["", [autocompleteObjectValidator()]],
            charStat: ["", [autocompleteObjectValidator()]],
        });
        this.formCCS3.valueChanges.subscribe((val) => {
            this.startDate = this.formatDate(new Date(val.startDate));
            this.endDate = this.formatDate(new Date(val.endDate));
            this.cdr.detectChanges();
        });

        this.infoWindowOpened = null;
        this.previous_info_window = null;
        this.getClients();
    }

    ngOnInit() {
        this.setCurrentLocation();
        this.checkRoutePermission();
        //this.getChargingStation();
        this.getAllCity();
        this.getAllConnectorTypes();
        const id = this.route.snapshot.params["id"];
        this.idIndex = id;
        if (this.idIndex >= 0) {
            this.selectedIndex = this.idIndex;
        } else {
            this.selectedIndex = 0;
        }

        this.initialize();
        if (!localStorage.getItem("userDetails")) {
            this.router.navigateByUrl("/login");
        }
        this.setMarkerAtLocation();
        this.filterEntity = new ChargingStation();
        this.filterType = MatTableFilter.ANYWHERE;

        if (
            this.localStorage.role_code == "SC" ||
            this.localStorage.role_code == "SO"
        ) {
            this.formCCS.get("charClient").disable();
            this.formCCS.get("charCPO").disable();
        } else if (
            this.localStorage.role_code == "CPO" ||
            this.localStorage.role_code == "ADMIN"
        ) {
            this.formCCS.get("charClient").disable();
        }
        //this.getAllCharginingStation();
        // var x = document.getElementById("actiondiv");
        // x.style.display = "none";
    }

    private openFilterBox() {
        this.filterBox = !this.filterBox;
    }

    private openListFilterBox() {
        this.listFilterBox = !this.listFilterBox;
    }
    private openListFilterBox1() {
        this.listFilterBox1 = !this.listFilterBox1;
    }
    private openListFilterBox2() {
        this.listFilterBox2 = !this.listFilterBox2;
    }
    private openListFilterBox3() {
        this.listFilterBox3 = !this.listFilterBox3;
    }

    private setCurrentLocation() {
        this.geoLocationService.getPosition().subscribe((pos: any) => {
            this.lat = +pos.coords.latitude;
            this.lng = +pos.coords.longitude;
            this.zoom = 12;
            this.radiusLat = this.lat;
            this.radiusLong = this.lng;
        });
    }

    setMarkerAtLocation() {
        this.stationMarker = [];
        let params = {
            connector_type_id: 0,
            lat: this.lat,
            lng: this.lng,
            radius: 5,
        };
        this.chargingStations = [];
        this.localStorage = JSON.parse(localStorage.getItem("userDetails"));
        // const gpu = new GPU();
        // const gpuMatrix = gpu.createKernel(function(){})
        if (
            this.localStorage.role_code == "EU" ||
            this.localStorage.role_code == null
        ) {
            this.chargingStationService
                .getChargingStationsByUserRoleAndLatLongUW(
                    this.localStorage.userId,
                    params,
                )
                .subscribe(
                    (data: any) => {
                        this.preloader.close();
                        if (data.count > 0) {
                            let tempStation = data.data;
                            this.chargingStations = data.data;
                            this.getChargingStation();
                            let unit = "K";
                            for (var i = 0; i < tempStation.length; i++) {
                                if (
                                    this.lat == tempStation[i].lat &&
                                    this.lng == tempStation[i].lng
                                ) {
                                    //return 0;
                                } else {
                                    var radlat1 = (Math.PI * this.lat) / 180;
                                    var radlat2 =
                                        (Math.PI * tempStation[i].lat) / 180;
                                    var theta = this.lng - tempStation[i].lng;
                                    var radtheta = (Math.PI * theta) / 180;
                                    var dist =
                                        Math.sin(radlat1) * Math.sin(radlat2) +
                                        Math.cos(radlat1) *
                                            Math.cos(radlat2) *
                                            Math.cos(radtheta);
                                    if (dist > 1) {
                                        dist = 1;
                                    }
                                    dist = Math.acos(dist);
                                    dist = (dist * 180) / Math.PI;
                                    dist = dist * 60 * 1.1515;
                                    if (unit == "K") {
                                        dist = dist * 1.609344;
                                    }
                                }
                                if (dist <= this.circleMapRadius / 1000) {
                                    tempStation[i].infoWindowShow = true;
                                    this.stationMarker.push(tempStation[i]);
                                    this.close_infoWinow();
                                    if (this.stationMarker.length >= 50) {
                                        break;
                                    }
                                }
                            }
                        }
                    },
                    (err) => {},
                );
        } else {
            this.chargingStationService
                .getAllChargingStationsWithChargersAndConnectorsCCS(
                    this.localStorage.userId,
                    this.selectedClient_id,
                    this.selectedCpo_id,
                    this.selectedStation_id,
                    params,
                )
                .subscribe(
                    (data: any) => {
                        this.preloader.close();
                        if (data.count > 0) {
                            let tempStation = data.data;
                            this.chargingStations = data.data;
                            this.getChargingStation();
                            let unit = "K";
                            for (var i = 0; i < tempStation.length; i++) {
                                if (
                                    this.lat == tempStation[i].lat &&
                                    this.lng == tempStation[i].lng
                                ) {
                                    //return 0;
                                } else {
                                    var radlat1 = (Math.PI * this.lat) / 180;
                                    var radlat2 =
                                        (Math.PI * tempStation[i].lat) / 180;
                                    var theta = this.lng - tempStation[i].lng;
                                    var radtheta = (Math.PI * theta) / 180;
                                    var dist =
                                        Math.sin(radlat1) * Math.sin(radlat2) +
                                        Math.cos(radlat1) *
                                            Math.cos(radlat2) *
                                            Math.cos(radtheta);
                                    if (dist > 1) {
                                        dist = 1;
                                    }
                                    dist = Math.acos(dist);
                                    dist = (dist * 180) / Math.PI;
                                    dist = dist * 60 * 1.1515;
                                    if (unit == "K") {
                                        dist = dist * 1.609344;
                                    }
                                }
                                if (dist <= this.circleMapRadius / 1000) {
                                    tempStation[i].infoWindowShow = true;
                                    this.stationMarker.push(tempStation[i]);
                                    this.close_infoWinow();
                                    // this.clickedMarker(event,this.chargingStations[i]);
                                    if (this.stationMarker.length >= 50) {
                                        break;
                                    }
                                }
                            }
                        }
                    },
                    (err) => {},
                );
        }
    }
    toRad(value) {
        return (value * Math.PI) / 180;
    }
    // ngAfterViewInit() {
    //   this.ngZone.runOutsideAngular(() => this.initChart());
    // }

    initialize() {
        this.actionDialog();
        this.batteryDialog();
        this.getConsumptionBilledAmount(this.formCCS2.value);
        this.getConsumptionReportbyuserid(this.formCCS3.value);
    }

    // applyFilter(event: Event) {
    //   const filterValue = (event.target as HTMLInputElement).value;
    //   this.dataSource.filter = filterValue.trim().toLowerCase();

    //   if (this.dataSource.paginator) {
    //     this.dataSource.paginator.firstPage();
    //   }
    // }
    getChargingStation() {
        for (var i = 0; i < this.chargingStations.length; i++) {
            if (this.chargingStations[i].status == "N") {
                this.chargingStations[i].statusString = "Inactive";
            } else {
                this.chargingStations[i].statusString = "Active";
            }
        }
        this.dataSource = new MatTableDataSource(this.chargingStations);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    // getChargingStation(){
    //   this.chargingStations  = [];
    //   this.localStorage = JSON.parse( localStorage.getItem('userDetails'));
    //   // this.chargingStationService.getAllChargingStationsWithChargersAndConnectors().subscribe(
    //   this.chargingStationService.getActiveChargingStationsWithChargersAndConnectorsCW(this.localStorage.userId ).subscribe(
    //     (data:any)=>{
    //       this.preloader.close();
    //       if(data.count > 0){

    //         this.chargingStations = [];
    //         let tempChargingStation  = data.data;
    //        let  tempChar = [];
    //         for(var i=0; i <tempChargingStation.length;i++){
    //           if(tempChargingStation[i].status == 'N'){
    //             tempChargingStation[i].statusString = 'Inactive';
    //           }else{
    //             tempChargingStation[i].statusString = 'Active';
    //           }
    //           tempChargingStation[i].infoWindowShow = true;
    //          // this.infoMarker = s_Obj;
    //           tempChar.push(tempChargingStation[i]);
    //           if(tempChar.length >= 50){

    //             this.chargingStations = this.chargingStations.concat(tempChar);
    //             tempChar = [];
    //           }

    //         }
    //         this.dataSource = new MatTableDataSource(this.chargingStations);
    //         this.dataSource.paginator = this.paginator;
    //         this.dataSource.sort = this.sort;
    //         this.cdr.detectChanges();
    //         this.filteredOptionsChStation = this.form.controls.chStation.valueChanges
    //         .pipe(
    //           startWith(''),
    //           map(value => typeof value === 'string' ? value : value.name),
    //           map(name => name ? this._filterChName(name) : this.chargingStations)
    //         );
    //       }
    //       else{
    //         this.snackBar.open(MessageConstant.NoRecordFoundMessage, 'Dismiss',{duration : 3000 })
    //         return;
    //       }
    //       // this.markers = new DummyData().markers;
    //     },(err)=>{

    //     }
    //   )
    // }

    displayCharger(item: any): string {
        return item && item.name ? item.name : "";
    }
    private _filterChName(name: string): any[] {
        const filterValue = name.toLowerCase();
        return this.chargingStations.filter((option) =>
            option.name.toLowerCase().includes(filterValue),
        );
    }

    applyFilter2() {
        // API call
        this.getConsumptionBilledAmount(this.formCCS2.value);
        this.listFilterBox2 = false;
    }

    applyFilter3() {
        // API call
        this.getConsumptionReportbyuserid(this.formCCS3.value);
        this.listFilterBox3 = false;
    }

    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);

        return `${year}-${month}-${day}`;
    }

    getConsumptionBilledAmount(formCCS2params) {
        const params = {
            p_station_id: -1,
            p_start_date: formCCS2params.startDate ?? this.startDate,
            p_end_date: formCCS2params.endDate ?? this.endDate,
            p_cpo_id: -1,
            user_id: this.localStorage.userId,
        };
        this.homeService.getConsumptionBilledAmount(params).subscribe({
            next: (res: any) => {
                if (res?.status && res?.data?.length) {
                    this.cpoCunsumDataSource = res?.data;
                    this.listFilterBox = false;
                } else {
                    this.cpoCunsumDataSource = [];
                }
                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error("API Error", err);
            },
        });
    }

    getConsumptionReportbyuserid(formCCS3params) {
        // console.log("Form Changed :", formCCS3params);

        const params: any = {
            start_date:
                new Date(formCCS3params.startDate)
                    .toISOString()
                    .split("T")[0] ?? this.startDate,
            end_date:
                new Date(formCCS3params.endDate).toISOString().split("T")[0] ??
                this.endDate,
        };

        if (formCCS3params.charCPO?.cpo_id) {
            params.cpo_id = formCCS3params.charCPO.cpo_id;

            if (formCCS3params.charStat?.station_id) {
                params.station_id = formCCS3params.charStat.station_id;
            }
        }

        this.homeService
            .getConsumptionReportbyuserid(this.localStorage.userId, params)
            .subscribe({
                next: (res: any) => {
                    if (res?.status && res?.data?.cpos?.length > 0) {
                        this.formatLedger(res.data);
                    } else {
                        // ✅ Clear table
                        this.ledgerRows = [];
                        this.cpoLedgerDataSource = [];
                    }

                    this.cdr.detectChanges();
                },
                error: (err) => {
                    console.error("API Error", err);
                },
            });
    }

    formatLedger(data: any) {
        this.ledgerRows = [];

        data.cpos.forEach((cpo: any) => {
            cpo.stations.forEach((station: any) => {
                station.users.forEach((user: any) => {
                    user.transactions.forEach((tx: any) => {
                        this.ledgerRows.push({
                            cpo_name: cpo.cpo_name,
                            station_name: station.station_name,
                            user_name: user.user_name,
                            user_id: user.user_id,
                            transaction_date: tx.transaction_date,
                            debit_amount: tx.debit_amount,
                            credit_amount: tx.credit_amount,
                            energy_consumed: tx.energy_consumed,
                            balance: tx.balance,
                            charger_display_id: tx.charger_display_id,
                            connector_no: tx.connector_no,
                            payment_status: tx.payment_status,
                            payment_mode: tx.payment_mode,
                        });
                    });
                });
            });
        });
    }

    tableExport2() {
        this.exportedData = [];

        for (let i = 0; i < this.ledgerRows.length; i++) {
            const tx = this.ledgerRows[i];

            const data = {
                "CPO Name": tx.cpo_name,
                "Station Name": tx.station_name,
                "User Name": tx.user_name || "Unknown",
                "User Id": tx.user_id,
                "Energy (kWh)": tx.energy_consumed
                    ? (tx.energy_consumed / 1000).toFixed(2)
                    : "",
                "Charger ID": tx.charger_display_id,
                "Connector No": tx.connector_no,
                "Debit Amount": tx.debit_amount ? `₹${tx.debit_amount}` : "",
                "Credit Amount": tx.credit_amount ? `₹${tx.credit_amount}` : "",
                Balance: tx.balance ? `₹${tx.balance}` : "",
                "Transaction Date": tx.transaction_date,
                "Payment Status": tx.payment_status,
                "Payment Mode": tx.payment_mode,
            };

            this.exportedData.push(data);
        }

        const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
            this.exportedData,
        );

        const workBook: XLSX.WorkBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workBook, workSheet, "Ledger Report");

        XLSX.writeFile(workBook, `Charging_Ledger_Report_${this.startDate}_to_${this.endDate}.xlsx`);
    }

    pdfExport2() {
        this.preloader.open();

        let doc = new jsPDF({
            orientation: "landscape", // table wide hai isliye landscape
        });

        this.exportedData = [];

        for (let i = 0; i < this.ledgerRows.length; i++) {
            const tx = this.ledgerRows[i];

            const data = [
                i + 1,
                tx.cpo_name,
                tx.station_name,
                tx.user_name || "Unknown",
                tx.user_id,
                tx.energy_consumed
                    ? (tx.energy_consumed / 1000).toFixed(2) + " kWh"
                    : "",
                tx.charger_display_id,
                tx.connector_no,
                tx.debit_amount ? "₹" + tx.debit_amount : "",
                tx.credit_amount ? "₹" + tx.credit_amount : "",
                tx.balance ? "₹" + tx.balance : "",
                tx.transaction_date,
                tx.payment_status,
                tx.payment_mode,
            ];

            this.exportedData.push(data);
        }

        const head = [
            [
                "#",
                "CPO Name",
                "Station Name",
                "User Name",
                "User Id",
                "Energy",
                "Charger",
                "Connector",
                "Debit Amt",
                "Credit Amt",
                "Balance",
                "Transaction Date",
                "Payment Status",
                "Payment Mode",
            ],
        ];

        let img = new Image();
        img.src = "assets/images/logos/logo_ezycharge_main.png";

        let createdDate = new Date().toLocaleString("en-GB");

        (doc as any).autoTable({
            head: head,
            body: this.exportedData,
            theme: "grid",

            headStyles: {
                fillColor: [11, 148, 68],
                fontSize: 9,
            },

            styles: {
                cellPadding: 2,
                fontSize: 8,
            },

            margin: { top: 25 },

            didDrawPage: () => {
                doc.addImage(img, 15, 7, 15, 9);

                doc.setFontSize(16);

                doc.text(
                    "Charging Ledger Report",
                    doc.internal.pageSize.getWidth() / 2,
                    12,
                    { align: "center" },
                );

                doc.setFontSize(9);

                doc.text("Date : " + createdDate, 15, 20);

                doc.text(
                    "Generated By : " + this.localStorage.f_Name,
                    doc.internal.pageSize.getWidth() - 15,
                    20,
                    { align: "right" },
                );
            },
        });

        // doc.output("dataurlnewwindow");

        doc.save(`Charging_Ledger_Report_${this.startDate}_to_${this.endDate}.pdf`);

        this.preloader.close();
    }

    toggleCpo(cpoIndex: number) {
        this.cpoLedgerDataSource[cpoIndex].expanded =
            !this.cpoLedgerDataSource[cpoIndex].expanded;
    }

    toggleStation(cpoIndex: number, sIndex: number) {
        const station = this.cpoLedgerDataSource[cpoIndex].stations[sIndex];
        station.expanded = !station.expanded;
    }

    toggleUser(cpoIndex: number, sIndex: number, uIndex: number) {
        const user =
            this.cpoLedgerDataSource[cpoIndex].stations[sIndex].users[uIndex];
        user.expanded = !user.expanded;
    }

    ngOnDestroy() {
        // if (this.chart1) {
        //   this.chart1.destroy();
        // }
        // if (this.chart2) {
        //   this.chart2.destroy();
        // }
    }

    initChart() {
        // this.chart1 = new ApexCharts(document.querySelector('#chart1'), this.charts[0]);
        // this.chart1.render();
        // this.chart2 = new ApexCharts(document.querySelector('#chart2'), this.charts[1]);
        // this.chart2.render();
    }

    isInfoWindowOpen(id) {
        return this.openedWindow == id; // alternative: check if id is in array
    }

    upgradeSingle(chargerDetails) {
        this.router.navigate([
            "/single/singleChargerUpgrade",
            {
                hePartNo: chargerDetails.hePartNo,
                serialNo: chargerDetails.serialNo,
            },
        ]);
    }

    radiusChange(value) {
        //this.circleMapRadiusChange(value*1000);
    }

    circleMapRadiusChange(value) {
        if (this.circleMapRadius == null && this.circleMapRadius == undefined) {
            this.circleMapRadius = 5000;
            this.zoom = 12;
        } else {
            this.circleMapRadius = value;
            var rads = this.circleMapRadius + this.circleMapRadius / 2;
            var scale = rads / 500;
            var zoomLevel = Number(16 - Math.log(scale) / Math.log(2));
            this.zoom = zoomLevel + 0.4;
            this.setMarkerAtLocation();
            // this.zoom = 22 - (value/1000);
            // if(this.zoom < 10){
            //   this.zoom = 10;
            // }
            // this.zoom= value.radiusValue;
        }
    }

    getStationDetails() {
        let params = {
            action: "edit",
            data: this.stationObj,
        };

        // const dialogRef = this.dialog.open(ViewStationComponent, {
        //   width: '1200px',
        //   data: params,
        //   autoFocus: false
        // });

        // dialogRef.afterClosed().subscribe(result => {

        // ;
        // });
    }
    getChargerDetails() {
        // const dialogRef = this.dialog.open(ViewChargerComponent, {
        //   width: '1200px',
        //   data: this.stationObj,
        //   autoFocus: false
        // });
        // dialogRef.afterClosed().subscribe(result => {
        //   // this.moderate(result);
        //   //this.getChargingStations();
        // });
    }

    setOpened(itemIndex) {
        this.currentlyOpenedItemIndex = itemIndex;
    }

    setClosed(itemIndex) {
        if (this.currentlyOpenedItemIndex === itemIndex) {
            this.currentlyOpenedItemIndex = -1;
        }
    }
    mapReady(event: any) {
        this.map = event;
        //const input = document.getElementById('Map-Search');
        //this.searchBox = new google.maps.places.SearchBox(input);
        this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
            document.getElementById("Settings"),
        );
        this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
            document.getElementById("Profile"),
        );
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
            document.getElementById("actiondiv"),
        );
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
            document.getElementById("swappingDiv"),
        );
        this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
            document.getElementById("cdk-overlay-0"),
        );
        //this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        // this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.getElementById('Logout'));

        // this.searchBox.addListener('places_changed', () => this.goToSearchedPlace());
    }
    closeActionPanel() {
        var x = document.getElementById("actiondiv");
        x.style.display = "none";
    }
    actionDialog() {
        //this.actionClicked = !this.actionClicked;
        var x = document.getElementById("actiondiv");
        var y = document.getElementById("swappingDiv");
        if (
            x != null &&
            x != undefined &&
            x.style != null &&
            x.style != undefined
        ) {
            if (x.style.display === "none" || x.style.display === "") {
                x.style.display = "block";
                y.style.display = "none";
            } else {
                x.style.display = "none";
            }
        }

        //event.stopPropagation();
    }

    batteryDialog() {
        this.batteryDial = !this.batteryDial;
        var x = document.getElementById("swappingDiv");
        var y = document.getElementById("actiondiv");
        if (
            x != null &&
            x != undefined &&
            x.style != null &&
            x.style != undefined
        ) {
            if (x.style.display === "none" || x.style.display === "") {
                x.style.display = "block";
                y.style.display = "none";
            } else {
                x.style.display = "none";
            }
        }
        //event.stopPropagation();
    }
    closeEvent() {
        this.actionClicked = false;
    }
    onVehicleSelect(item) {
        this.activeState = item;
    }
    onChStationSelect(item) {
        this.activeChStation = item;
    }
    resetAll() {
        this.form.reset();
    }
    open() {
        this.show = true;
    }
    hide() {
        this.show = false;
    }
    clear() {
        this.search = "";
    }
    cityHide() {
        this.cityShow = false;
    }
    cityClear() {
        this.citySearch = "";
    }
    getAllCity() {
        this.countryService.getAllCities().subscribe(
            (resp: any) => {
                this.cities = resp.data;
            },
            (err) => {},
        );
    }
    cityChange(val) {
        this.filterdCityOptions = this.cities.filter((item) =>
            item.name
                .toLowerCase()
                .includes(this.cityOptionSearch.toLowerCase()),
        );
        this.citySearch = val;
        this.cityShow = true;
        if (val != "") {
            this.cityShow = true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {}, 500);
        } else {
            this.cityClear();
            this.cityHide();
        }
    }
    cityPick(event) {
        this.cityOptionSearch = event.name;
        this.cityHide();
    }
    stationChange(val) {
        this.filterdStationOptions = this.chargingStations.filter((item) =>
            item.name
                .toLowerCase()
                .includes(this.chStationSearch.toLowerCase()),
        );
        this.search = val;
        this.show = true;
        if (val != "") {
            this.show = true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {}, 500);
        } else {
            this.clear();
            this.hide();
        }
    }
    locationStation(event) {
        this.chStationSearch = event.name;
        this.hide();
    }

    viewDetails(element) {
        this.chargingStationService.chargerDetail = element;
        this.chargingStationService.tabIndex = this.selectedIndex;
        this.router.navigate(["/chargingStation/viewDetails"]);
    }
    changeVisibility(visibleOption, ev) {
        this.cdr.reattach();
        this.cdr.detectChanges();
        this.dataSource.filteredData = this.chargingStations;
        this.dataSource.data = this.chargingStations;
        // ev.stopPropagation();
        if (visibleOption == "nameSearch") {
            this.nameSearch = !this.nameSearch;
            this.filterEntity.name = "";
        }

        if (visibleOption == "cpoSearch") {
            this.cpoSearch = !this.cpoSearch;
            this.filterEntity.cpo_name = "";
        }
        if (visibleOption == "stationSearch") {
            this.stationSearch = !this.stationSearch;
            this.filterEntity.code = "";
        }
        if (visibleOption == "cpSearch") {
            this.cpSearch = !this.cpSearch;
            this.filterEntity.cp_name = "";
        }
        if (visibleOption == "mobileSearch") {
            this.mobileSearch = !this.mobileSearch;
            this.filterEntity.mobile = null;
        }
        if (visibleOption == "emailSearch") {
            this.emailSearch = !this.emailSearch;
            this.filterEntity.email = "";
        }
        if (visibleOption == "addressSearch") {
            this.addressSearch = !this.addressSearch;
            this.filterEntity.address1 = "";
        }
        if (visibleOption == "statusSearch") {
            this.statusSearch = !this.statusSearch;
            this.filterEntity.statusString = "";
        }
    }
    tableExport() {
        this.exportedData = [];
        for (let i = 0; i < this.dataSource.filteredData.length; i++) {
            var chargerModel = this.dataSource.filteredData[i];
            //this.exportedData.push({name: `name${i}`, description: `description${i}`,
            //statusString: `statusString${i}`});
            var data = {
                "CPO Name": chargerModel.cpo_name,
                "Station Code": chargerModel.code,
                Name: chargerModel.name,
                "Contact Person Name": chargerModel.cp_name,
                Mobile: chargerModel.mobile,
                Address: chargerModel.address1,
                Status: chargerModel.statusString,
            };
            this.exportedData.push(data);
        }

        const workSheet = XLSX.utils.json_to_sheet(this.exportedData);
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workBook, workSheet, "sales disptch");
        XLSX.writeFile(workBook, "Charging Station.xlsx");
    }
    onTabChange(event) {
        this.selectedIndex = event.index;
    }
    searchFilter() {
        this.circleMapRadius = this.radiusSearch * 1000;
        var rads = this.circleMapRadius + this.circleMapRadius / 2;
        var scale = rads / 500;
        var zoomLevel = Number(16 - Math.log(scale) / Math.log(2));
        this.zoom = zoomLevel + 0.4;
        this.filterOnMap();
    }
    filterOnMap() {
        this.close_infoWinow();
        this.stationMarker = [];

        let params = {
            connector_type_id: this.connectorSearch,
            lat: this.lat,
            lng: this.lng,
            radius: this.radiusSearch,
        };
        this.chargingStationService
            .getAllChargingStationsWithChargersAndConnectorsCCS(
                this.localStorage.userId,
                this.selectedClient_id,
                this.selectedCpo_id,
                this.selectedStation_id,
                params,
            )
            .subscribe(
                (resp: any) => {
                    this.preloader.close();
                    if (resp.count > 0) {
                        let tempStation = resp.data;
                        let unit = "K";
                        for (var i = 0; i < tempStation.length; i++) {
                            this.stationMarker.push(tempStation[i]);
                            tempStation[i].infoWindowShow = true;
                            if (this.stationMarker.length >= 50) {
                                break;
                            }
                        }
                        //this.cdr.detectChanges();
                    }
                },
                (err) => {},
            );
    }
    refreshMap() {
        this.lat;
        this.lng;
        //this.cdr.detectChanges();
    }
    bookings(charger) {
        this.router.navigate(["/booking/crud/create"]);
        this.chargerService.chargerBookingobj = charger;
    }
    getAllConnectorTypes() {
        this.masterService.getConnectorTypes().subscribe(
            (data: any) => {
                this.connectorTypes = data;
            },
            (err) => {},
        );
    }
    close_infoWinow() {
        if (this.previous_info_window != null) {
            this.openedWindow = null;
            this.previous_info_window.infoWindowShow = true;
            this.previous_info_window = null;
        }
    }
    clickedMarker(s_Obj) {
        this.close_infoWinow();
        let params = {
            station_id: s_Obj.id,
        };
        this.chargerService
            .getChargersDynamicFilterCW(this.localStorage.userId, params)
            .subscribe(
                (resp: any) => {
                    this.preloader.close();

                    if (this.previous_info_window != null) {
                        if (this.previous_info_window.id == s_Obj.id) {
                            this.openedWindow = null;
                            s_Obj.infoWindowShow = true;
                            this.previous_info_window = null;
                        } else {
                            this.openedWindow = s_Obj.id;
                            s_Obj.infoWindowShow = false;
                            this.previous_info_window = s_Obj;
                        }
                    } else {
                        s_Obj.infoWindowShow = false;
                        this.openedWindow = s_Obj.id;
                        this.previous_info_window = s_Obj;
                    }

                    this.infoMarker = s_Obj;
                    //  if(this.infoMarker.amenities.length >0){
                    //    this.ameniteExits = true;
                    //  }
                    this.showingInfoWindow = true;
                    this.stationObj = s_Obj;
                    this.showStationDetails = true;
                    this.chargers = resp.data;

                    this.cdr.detectChanges();
                },
                (err) => {},
            );
    }
    pdfExport() {
        this.preloader.open();
        var doc = new jsPDF({
            // set needed dimensions for any elemen
        });
        this.exportedData = [];
        for (let i = 0; i < this.dataSource.filteredData.length; i++) {
            var chrger = this.dataSource.filteredData[i];
            //this.exportedData.push({name: `name${i}`, description: `description${i}`,
            //statusString: `statusString${i}`});
            var data = [
                chrger.cpo_name,
                chrger.code,
                chrger.name,
                chrger.cp_name,
                chrger.mobile,
                chrger.address1,
                chrger.statusString,
            ];

            this.exportedData.push(data);
        }
        var img = new Image();
        var imgRight = new Image();
        var src = "assets/images/logos/logo_sparkev_main.png";
        var srcSparkEV = "assets/images/logos/logo_sparkev_main.png";
        imgRight.src = srcSparkEV;
        var createdDate = new Date().toLocaleString("en-GB");
        img.src = src;
        doc.setFontSize(11);
        doc.setTextColor(100);
        doc.setFontSize(18);

        (doc as any).autoTable({
            head: this.head,
            body: this.exportedData,
            theme: "grid",
            headStyles: { fontStyle: "majalla", fillColor: [11, 148, 68] },
            styles: {
                cellPadding: 1,
                fontSize: 8,
            },

            margin: { top: 22 },
            didDrawCell: (data) => {},
            didDrawPage: (data) => {
                doc.addImage(img, 15, 7, 15, 6);
                // doc.addImage(imgRight, 170, 7, 25, 6);

                doc.text(
                    "Charging Station Report",
                    doc.internal.pageSize.getWidth() / 2,
                    11,
                    { align: "center" },
                );

                doc.setTextColor(211, 211, 211);
                doc.setFontSize(60);
                doc.setGState(doc.GState({ opacity: 0.6 }));
                doc.text("Confidential/Not for Public use", 25, 285, null, 60);
                doc.setGState(doc.GState({ opacity: 1 }));
                doc.setTextColor(100);
                doc.setFontSize(9);
                doc.text("Date:" + createdDate, 15, 18);

                doc.text("Generated By:" + this.localStorage.f_Name, 195, 18, {
                    align: "right",
                });
                doc = this.addWaterMark(doc);
            },
        });

        // below line for Open PDF document in new tab
        doc.output("dataurlnewwindow");
        this.preloader.close();
        // below line for Download PDF document
        doc.save("Charging Station report.pdf");
    }
    addWaterMark(doc) {
        var newpage = doc.getNumberOfPages();
        const i = doc.internal.getNumberOfPages();
        doc.setTextColor(100);
        doc.setFontSize(10);
        //Print Page 1 of 4 for example
        doc.text(
            "Page " + String(i) + " of " + String(newpage),
            210 - 20,
            297 - 10,
            null,
            null,
            "right",
        );
        return doc;
    }

    checkRoutePermission() {
        this.localStorage = JSON.parse(localStorage.getItem("userDetails"));
        let nav_list = this.localStorage.nav_list_with_tab;
        nav_list.filter((x) => {
            if (x.id === "home") {
                this.objectData = x;
                // console.log("this.objectData");
                // console.log(this.objectData);
                if (
                    this.objectData.children != null ||
                    this.objectData.children != undefined
                ) {
                    this.objectData.children.filter((y) => {
                        if (y.id === "mapView") {
                            this.dyanmicMapView = true;
                        }
                        if (y.id === "listView") {
                            this.dyanmicListView = true;
                        }
                        if (y.id === "cpoCunsumView") {
                            this.dyanmicCpoConsumListView = true;
                        }
                        if (y.id === "cpoLeagerView") {
                            this.dyanmicCpoStationConsumListView = true;
                        }
                    });
                }
            }
        });
    }
    getClients() {
        let selectedClient;
        this.clientList = JSON.parse(localStorage.getItem("ClientList"));
        this.localClient = localStorage.getItem("selectedClient");
        if (this.localStorage.role_code != "END") {
            if (this.clientList != null && this.clientList != undefined) {
                if (this.localClient != null || this.localClient != undefined) {
                    selectedClient = this.clientList.filter(
                        (client) =>
                            client.client_id === Number(this.localClient),
                    );
                    const toSelect = selectedClient[0];
                    this.selectedClient_id = toSelect.client_id;
                    this.formCCS.get("charClient").setValue(toSelect);
                    // this.cdr.detectChanges();
                    // this.getCPOByClient(toSelect.client_id);
                    this.getCPOByClient("-1");
                } else {
                    const toSelect = this.clientList[0];
                    this.selectedClient_id = toSelect.client_id;
                    this.formCCS.get("charClient").setValue(toSelect);
                    // this.cdr.detectChanges();
                    // this.getCPOByClient(toSelect.client_id);
                    this.getCPOByClient("-1");
                }
            }
            this.filteredOptionsCharClient =
                this.formCCS.controls.charClient.valueChanges.pipe(
                    startWith(""),
                    map((value) =>
                        typeof value === "string" ? value : value.client_name,
                    ),
                    map((name) =>
                        name ? this._filterCharClient(name) : this.clientList,
                    ),
                );
        }
    }
    private _filterCharClient(name: string): any[] {
        this.formCCS.get("charCPO").setValue("");
        this.formCCS.get("charStat").setValue("");
        const filterValue = name.toLowerCase();
        return this.clientList.filter((option) =>
            option.client_name.toLowerCase().includes(filterValue),
        );
    }
    displayCharClient(item: any): string {
        return item && item.client_name ? item.client_name : "";
    }
    onClientChange(client_id) {
        this.cpoList = [];
        this.stationList = [];
        this.formCCS.get("charCPO").setValue("");
        this.formCCS.get("charStat").setValue("");
        this.setCPOStation(client_id);
    }
    getCPOByClient(client_id) {
        this.cpoList = JSON.parse(localStorage.getItem("CpoList"));
        if (this.localStorage.role_code != "END") {
            if (this.cpoList != null && this.cpoList != undefined) {
                const toSelect =
                    this.cpoList.length == 1
                        ? this.cpoList[0]
                        : this.cpoList[1];
                // console.log("this.cpoList");
                // console.log(this.cpoList);

                // this.selectedCpo_id = toSelect.cpo_id;
                // this.formCCS.get("charCPO").setValue(toSelect);
                this.selectedCpo_id = "-1";
                this.getStationByCPO("-1");
            }
            this.filteredOptionsCharCPO =
                this.formCCS.controls.charCPO.valueChanges.pipe(
                    startWith(""),
                    map((value) =>
                        typeof value === "string" ? value : value.cpo_name,
                    ),
                    map((name) =>
                        name ? this._filterCharCPO(name) : this.cpoList,
                    ),
                );
        }
    }
    private _filterCharCPO(name: string): any[] {
        this.formCCS.get("charStat").setValue("");
        const filterValue = name.toLowerCase();
        return this.cpoList.filter((option) =>
            option.cpo_name.toLowerCase().includes(filterValue),
        );
    }
    displayCharCPO(item: any): string {
        return item && item.cpo_name ? item.cpo_name : "";
    }
    onCPOChange(id) {
        this.stationList = [];
        this.selectedCpo_id = id;
        this.formCCS.get("charStat").setValue("");
        this.getStationByCPO(id);
    }
    getStationByCPO(id) {
        this.stationList = JSON.parse(localStorage.getItem("StationList"));
        this.station = [];
        if (this.localStorage.role_code != "END") {
            for (var i = 0; i < this.stationList.length; i++) {
                if (id == this.stationList[i].cpo_id) {
                    this.station.push(this.stationList[i]);
                }

                if (this.stationList[i].station_id == -1 && id != -1) {
                    this.station.push(this.stationList[i]);
                }
                if (id == -1) {
                    this.station.push(this.stationList[i]);
                }
            }
            if (
                this.station != null &&
                this.station != undefined &&
                this.station.length > 0
            ) {
                let toSelect;
                if (this.selectedCpo_id == -1) {
                    toSelect = this.station[0];
                } else {
                    toSelect =
                        this.station.length == 1
                            ? this.station[0]
                            : this.station[1];
                }
                // const toSelect = this.station.length == 1 ? this.station[0] : this.station[1];

                // this.selectedStation_id = toSelect.station_id;
                this.selectedStation_id = "-1";
                // this.formCCS.get("charStat").setValue(toSelect);
                this.setMarkerAtLocation();
                this.getChargingStation();
            }
            this.filteredOptionsCharStat =
                this.formCCS.controls.charStat.valueChanges.pipe(
                    startWith(""),
                    map((value) =>
                        typeof value === "string" ? value : value.station_name,
                    ),
                    map((station_name) =>
                        station_name
                            ? this._filterCharStat(station_name)
                            : this.station,
                    ),
                );
        }
    }
    private _filterCharStat(name: string): any[] {
        const filterValue = name.toLowerCase();
        return this.station.filter((option) =>
            option.station_name.toLowerCase().includes(filterValue),
        );
    }
    displayCharStat(item: any): string {
        return item && item.station_name ? item.station_name : "";
    }
    onStationChange(id) {
        this.selectedStation_id = id;
        this.getChargingStation();
        this.setMarkerAtLocation();
    }

    setCPOStation(client_id) {
        this.setCpoStationService.setCpoStationDetails(client_id);
        setTimeout(() => {
            this.getCPOByClient(client_id);
        }, 700);
    }
    //   localStorage.removeItem("CpoList");
    //   localStorage.removeItem("StationList");
    //   let params:any;
    //   if(this.localStorage.role_code == 'CPO'){
    //      params = {
    //       cpo_id :this.localStorage.cpo_id
    //     }
    //   }else{
    //      params = { };
    //   }

    //   this.localCpolist = [];
    //   this.localStationlist = [];

    //   this.accountService.cpoStationDetailsByClientId(this.localStorage.userId, client_id, params).subscribe(
    //     (resp: any) => {
    //       if (resp.status == true) {
    //         this.clientCpoStaDetail = resp.data;
    //         localStorage.setItem('clientCpoStaDetails', JSON.stringify(this.clientCpoStaDetail));

    //         for (var i = 0; i < this.clientCpoStaDetail.cpos.length; i++) {
    //           var cpoList = {
    //             cpo_id: this.clientCpoStaDetail.cpos[i].cpo_id,
    //             cpo_name: this.clientCpoStaDetail.cpos[i].cpo_name,
    //           }
    //           if (!this.localCpolist.find(c => c.cpo_id === this.clientCpoStaDetail.cpos[i].cpo_id)) {
    //             this.localCpolist.push(cpoList);
    //           }
    //         }
    //         for (var i = 0; i < this.clientCpoStaDetail.stations.length; i++) {
    //           var stationList = {
    //             cpo_id: this.clientCpoStaDetail.stations[i].cpo_id,
    //             cpo_name: this.clientCpoStaDetail.stations[i].cpo_name,
    //             station_id: this.clientCpoStaDetail.stations[i].station_id,
    //             station_name: this.clientCpoStaDetail.stations[i].station_name,
    //           }
    //           if (!this.localCpolist.find(st => st.station_id === this.clientCpoStaDetail.stations[i].station_id)) {
    //             this.localStationlist.push(stationList);
    //           }

    //         }
    //         localStorage.setItem('CpoList', JSON.stringify(this.localCpolist));
    //         localStorage.setItem('StationList', JSON.stringify(this.localStationlist));
    //         this.getCPOByClient(client_id);
    //       } else {
    //         var error = resp.message;
    //       }
    //     }, (err) => { }
    //   );
    // }
}
